import React from 'react';
import * as _ from 'lodash';

import {Modal, Button} from 'react-bootstrap';
import {Box} from 'reactjs-admin-lte';
import ReactJson from 'react-json-view';
import FontAwesome from 'react-fontawesome';
import ConfirmPopup from '../../component/element/ConfirmPopup';
import API from '../../utils/api';
import Diff from '../../component/element/Diff';

export default class extends React.Component {

  static defaultProps = {
    config_options_url: '/admin/config_options',
    config_history_url: '/admin/config_options_rev',
  };

  constructor(...props) {
    super(...props);

    this.state = {
      confirm: false,
      loading: false,
      data: [],
      editItem: {},
    };
  }

  postConfig(data) {
    return API.post(this.props.config_options_url, data).
        then((response) => {
          console.log(response.data);
          this.props.notification.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกข้อมูลเรียบร้อยแล้ว',
            level: 'success',
            position: 'tc',
          });
        }).
        catch((error) => {
          console.log(error);
          this.props.notification.addNotification({
            title: 'แจ้งเตือน',
            message: 'error',
            level: 'error',
            position: 'tc',
          });
        });
  }

  loadHistoryData() {
    this.setState({loading: true, confirm: false});
    return API.get(this.props.config_history_url +
                   `?option_name=${this.props.item.option_name}`).
        then((response) => {
          if (response && response.data) {
            const data = _.map(response.data.data, item => ({
              collapsed: true,
              diff: false,
              ...item,
            }));
            this.setState({
              data: data,
              loading: false,
            });
          }
        }).
        catch(function(error) {
          console.log(error);
          window.alert(error);
        });
  }

  resetState() {
    this.setState({
      confirm: false,
      loading: false,
      data: [],
      editItem: {},
    });
  }

  closeModal = (e) => {
    const {onHide} = this.props;
    this.resetState();
    return typeof onHide === 'function' && onHide(e);
  };

  revertRevision = () => {
    this.setState({loading: true, confirm: false});
    this.postConfig(this.state.editItem).then((resp) => {
      const {onChange, onHide} = this.props;
      this.resetState();
      typeof onChange === 'function' && onChange(resp);
      typeof onHide === 'function' && onHide(resp);
    });
  };

  historyToggle = (toggle_index) => {
    return () => {
      let {data} = this.state;
      this.setState({
        data: _.map(data, (item, index) => {
          if (index !== toggle_index) {
            return item;
          }

          return {
            ...item,
            collapsed: !item.collapsed,
          };
        }),
      });
    };
  };

  toggleDiff = (toggle_index) => {
    return () => {
      let {data} = this.state;
      this.setState({
        data: _.map(data, (item, index) => {
          if (index !== toggle_index) {
            return item;
          }
          return {
            ...item,
            diff: !item.diff,
          };
        }),
      });
    };
  };

  render() {
    const {props, state} = this;
    const {modal, item} = props;
    const {data, confirm, loading} = state;
    const sortedHistoryData = _.sortBy(data, 'added_date').reverse();
    return (
        <Modal show={modal} enforceFocus={false}
               dialogClassName={'midwidth-dialog'}
               onEnter={this.loadHistoryData.bind(this)}
               onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>{`ประวัติการแก้ไข : ${item.option_name}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{maxHeight: '500px', overflow: 'auto'}}>
            <Box loading={loading}>
              <Box.Body>
                <div className={'table-responsive admin-config-history'}>
                  <table
                      className={'table table-striped table-bordered table-hover'}>
                    <thead>
                    <tr className={'bg-primary'}>
                      <th>Added Date</th>
                      <th>Option Value</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {_.isEmpty(sortedHistoryData) ?
                        <tr>
                          <td colSpan={3}
                              className={'text-center'}>ไม่พบประวัติการแก้ไขข้อมูล
                          </td>
                        </tr>
                        : null}
                    {_.map(sortedHistoryData,
                        (history_item, index) => {

                          return (
                              <tr key={index}>
                                <td>{history_item.added_date}</td>
                                <td>
                                  {history_item.data_type === 'JSON' ?
                                      <div>
                                        {history_item.diff ?
                                            <Diff type="json"
                                                  inputA={item.option_value}
                                                  inputB={history_item.option_value} />
                                            :
                                            <ReactJson
                                                src={history_item.option_value ||
                                                {}}
                                                collapsed={history_item.collapsed} />
                                        }
                                      </div>
                                      :
                                      <div>
                                        {history_item.diff ?
                                            <Diff type="chars"
                                                  inputA={item.option_value}
                                                  inputB={history_item.option_value} />
                                            :
                                            <div>{history_item.option_value ||
                                                  ''}</div>
                                        }
                                      </div>
                                  }
                                </td>
                                <td>
                                  {history_item.data_type === 'JSON' ?
                                      <span>
                                        <Button bsStyle={'default'}
                                                onClick={this.historyToggle(
                                                    index)}>
                                    <FontAwesome name={history_item.collapsed
                                        ? 'eye'
                                        : 'eye-slash'} />
                                  </Button>{' '}
                                  </span> : null}
                                  <Button bsStyle={'warning'}
                                          onClick={() => {
                                            this.setState({
                                              confirm: true,
                                              editItem: {
                                                ...item,
                                                option_value: history_item.option_value,
                                              },
                                            });
                                          }}>
                                    <FontAwesome name={'undo'} /> Revert to this
                                                                  version
                                  </Button>
                                  {' '}
                                  <button type={'text'}
                                          className={'btn btn-default'}
                                          onClick={this.toggleDiff(index)}
                                  >Diff
                                  </button>

                                </td>
                              </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </Box.Body>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <div className={'text-right'}>
              <Button bsStyle={'default'}
                      onClick={this.closeModal}>
                <FontAwesome name={'close'} /> ปิด
              </Button>
            </div>

            <ConfirmPopup show={confirm} title="ยืนยัน"
                          confirmTitle="ยืนยัน" cancelTitle="ยกเลิก"
                          message="ยืนยันการแก้ไขข้อมูล"
                          onConfirm={this.revertRevision}
                          onHide={() => {this.setState({confirm: false});}}
            />
          </Modal.Footer>
        </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/view/debug/AdminConfigHistory.js